/** Список полей пользователя */
const columnDataGridUser = [
  {
    dataField: 'userId',
    dataType: 'number',
    caption: 'ID',
    width: 65,
    sortOrder: 'asc'
  },
  {
    dataField: 'userName',
    dataType: 'string',
    caption: 'Логин',
    width: 120
  },
  {
    dataField: 'name',
    dataType: 'string',
    caption: 'ФИО',
    width: 200
  },
  {
    dataField: 'phoneNumber',
    dataType: 'string',
    caption: 'Телефон',
    width: 120
  },
  {
    dataField: 'deletedFlag',
    dataType: 'boolean',
    caption: 'Деактивирован',
    width: 60,
    cellRender: true,
    notAllowSearch: true,
    headerFilter: true
  },
  {
    dataField: 'isVendorUser',
    dataType: 'boolean',
    caption: 'Внутренний сотрудник',
    width: 60,
    cellRender: true,
    notAllowSearch: true,
    headerFilter: true
  },
  {
    dataField: 'emailAddress',
    dataType: 'string',
    caption: 'Email',
    width: 120
  },
  {
    dataField: 'requestId',
    dataType: 'string',
    caption: 'Номер заявки',
    width: 120
  },
  {
    dataField: 'notes',
    dataType: 'string',
    caption: 'Примечание',
    width: 200
  },
  {
    dataField: 'consentDateFrom',
    dataType: 'date',
    caption: 'Согласие с'
  },
  {
    dataField: 'consentDateTo',
    dataType: 'date',
    caption: 'Согласие по'
  }
];

export default columnDataGridUser;
